import React, { useState } from "react"
import { useLocation } from "react-router"
import { Outlet } from "react-router-dom"

import BreadCrumbs from "../components/BreadCrumbs"
import Footer from "../components/Common/Footer"
import Header from "../components/Common/Header"
import PageTitle from "../components/PageTitle"
import RoutesConfig from "../routes/RoutesConfig"

export function PageLayout() {
    const location = useLocation()
    const [currentPageTitle, setcurrentPageTitle] = useState()
    return (
        <div className="pt-[103px]">
            <Header />
            { !location.pathname.includes("home") && 
                <div className="flex flex-col px-8 ">
                
                    <BreadCrumbs routes={ RoutesConfig } currentPageTitle = { currentPageTitle } />
                    <PageTitle routes={ RoutesConfig } />
                </div>
            }
            <div className="flex gap-6 w-full">
                <main className="w-full">
                    <Outlet context= { { setcurrentPageTitle } } />
                </main>
            </div>
            <Footer />
        </div>
    )
}
